import 'pixi.js';
import 'pixi-sound';
import 'pixi-particles';
import 'pixi-spine';
import 'reflect-metadata';
import DI from '@fantasmagames/slot/src/common/inversify/constants/DI';
import {RecodeGame} from 'src/RecodeGame';
import {BaseGame} from '@fantasmagames/slot/src/system/BaseGame';
import {IModule} from '@fantasmagames/slot/src/common/_interfaces/IModule';
import {FullscreenManager} from '@fantasmagames/core/src/screen/fullscreen/FullscreenManager';
import {CoreDI} from '@fantasmagames/core/src/di/CoreDI';
import {Logic} from '@fantasmagames/slot/src/logic/Logic';
import {GameViewManager} from 'src/GameViewManager';
import {SoundManager} from '@fantasmagames/slot/src/sound/SoundManager';
import {RecodeGameInstaller} from 'src/RecodeGameInstaller';
import {Layout} from '@fantasmagames/slot/src/layout/Layout';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {WebGlPerformanceCaveatResult} from '@fantasmagames/core/src/System';

let game: BaseGame;

(window as any).initGame = function (
	config: any,
	assets: any,
	deviceProps: any,
	callback: any,
	automation: any,
	callbackObj: any,
	gameSettingsConfig: any,
): void {
	// console.log(config, assets, deviceProps, callback, automation, callbackObj, gameSettingsConfig);
	// console.log((window as any).V);

	// (window as any).V.API.Events.subscribe('gameEvent', gameEvent, callbackObj);
	const gameBasePath: Function = getGameUrl;

	if (gameSettingsConfig) {
		(window as any)._certificationSettings = (window as any).V.API.Core.processCertificationSettings(gameSettingsConfig);
	}

	// TODO: Add check for IE and set context to webgl-experimental.
	const performanceCaveat = getMajorPerformanceCaveat();

	if (!__PRODUCTION__) {
		console.warn(performanceCaveat);
		console.warn(`Version: ${__VERSION__}`);
	}

	game = new RecodeGame('mysterywin', gameReady.bind(this, callback, callbackObj), gameBasePath, performanceCaveat);
};

function getMajorPerformanceCaveat(): number {
	const canvas = document.createElement('canvas');
	canvas.width = canvas.height = 1;
	document.body.appendChild(canvas);

	const gl =
		canvas.getContext('webgl', {failIfMajorPerformanceCaveat: true}) ||
		canvas.getContext('experimental-webgl', {failIfMajorPerformanceCaveat: true});

	canvas.parentNode.removeChild(canvas);

	if (!gl) {
		return WebGlPerformanceCaveatResult.SOFTWARE;
	}

	if (typeof (gl as any).getContextAttributes().failIfMajorPerformanceCaveat === 'undefined') {
		return WebGlPerformanceCaveatResult.NOT_IMPLEMENTED;
	}

	return WebGlPerformanceCaveatResult.HARDWARE;
}

function getGameUrl(data: any): string {
	return (window as any).V.API.UrlHelper.getGameUrl(data);
}

function gameEvent(eventName: string, ...data: any[]): void {
	// console.log(eventName, data);
}

function gameReady(callback: Function, callbackObj: any): void {
	RecodeGameInstaller.run(game, (window as any).V);

	const container = game.system.container;
	const modules = container.getAll<IModule>(DI.IModule);

	container.get<Layout>(DI.Layout).loadLayout('LAYOUT_TEMPLATE.json');
	container.get<Layout>(DI.Layout).loadLayout('LAYOUT_TEMPLATE_FREESPIN.json');

	container.get<Logic>(DI.Logic).init(() => {
		container.get<SoundManager>(DI.SoundManager).init(game.system.device);
		container.get<GameViewManager>(DI.ViewManager).init();

		for (const module of modules) {
			module.init();
		}

		for (const module of modules) {
			module.afterInit();
		}

		if (!__PRODUCTION__) {
			console.warn('NOT IN PRODUCTION');
			for (const module of modules) {
				module.addDebuggingComponent();
			}
			// tslint:disable-next-line: no-string-literal
			(document as any)['GAME'] = game;
			console.warn(game);
		}

		if (container.get<Logic>(DI.Logic).hasRestore) {
			for (const module of modules) {
				module.restore();
			}
		} else if ((container.get<Logic>(DI.Logic) as RecodeLogic).hasBonusGameFreeGamesRestore) {
			(container.get<Logic>(DI.Logic) as RecodeLogic).freeGamesBonusGameRestoreCallback = () => {
				for (const module of modules) {
					module.restore();
				}
			};
		}

		if (!game.system.device.desktop) {
			container.get<FullscreenManager>(CoreDI.FullscreenManager).forceUpdate();
		}

		// game.system.endLoading();
	});

	callback.call(callbackObj);
}



// WEBPACK FOOTER //
// ./src/recodeApp.ts